
      // LoginRadius V3 JS SDK (defines window.LoginRadiusSDK) + its stylesheet,
      // served from the same CDN base as the rest of the LR V3 assets.
      const lrContent = import.meta.env.VITE_LR_CONTENT;

      if (lrContent) {
        const base = lrContent.replace(/\/$/, "");

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${base}/LoginRadiusV3.css`;
        document.head.appendChild(link);

        const v3script = document.createElement("script");
        v3script.src = `${base}/LoginRadiusV3.js`;
        v3script.async = true;
        document.body.appendChild(v3script);
      }
    